<template>
    <v-dialog :value="isVisible" persistent :width="dialogWidth" >
        <v-card>
            
            <v-toolbar color="sucsess" >
                <v-toolbar-title>{{message}}</v-toolbar-title>
            </v-toolbar>
            
            <v-card-subtitle></v-card-subtitle>
            <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn color="error" @click="cancel"><v-icon>mdi-save</v-icon>No</v-btn>
                <v-btn color="primary" @click="confirm"><v-icon></v-icon>Yes</v-btn>
                
            </v-card-actions>
            

        </v-card>
    </v-dialog>
</template>
<script>
    export default{
        name: 'ConfirmationPanel',
        props:{
            message: String,
            isVisible:Boolean
        },
        data: function(){
            return {

                dialogWidth:'35%'
            }
        },
        methods:{
            async confirm(){
                this.$emit('confirm:click',true);
            },
            async cancel(){
                this.$emit('confirm:click',false);
            }
        }
    }
</script>